<template>
  <td :colspan="colspan">
    <div class="m3p-contact__2column">
      <div>
        <p v-for="(value, idx) in textList" :key="idx">{{ value }}</p>
      </div>

      <div class="m3p-contact__btnarea" v-if="editable === true">
        <a href="#" class="m3p-smalltext__btn" @click.prevent="openFormForEdit"
          >修正する</a
        >
      </div>
    </div>
  </td>
</template>

<script setup>
import { computed } from 'vue';

const emit = defineEmits(['open']);

const props = defineProps({
  text: {
    type: [String, Array],
    required: true
  },
  editable: {
    type: Boolean,
    required: true
  },
  colspan: {
    type: Number,
    required: false,
    default: 3
  }
});

const textList = computed(() => {
  if (typeof props.text === 'string') {
    return [props.text];
  } else {
    return props.text;
  }
});

const openFormForEdit = () => {
  emit('open');
};
</script>
<style scoped>
p {
  margin: 0;
}
</style>
